import { useQuery } from "@tanstack/react-query";
import systemPreferencesService from "../api/systemPreferencesService";

export const useSystemPreferences = () => {
  const { getSystemPreferences } = systemPreferencesService();

  return useQuery({
    queryKey: ["get-system-preferences"],
    queryFn: async () => {
      const res = await getSystemPreferences();
      return res.data;
    },
  });
};
